export function buildAccessShareQueryV1(id: string)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.AccessShareQueryV1, TCh.Domain.DataSharing',
		'Id': id,
	}
}

export function buildActiveSharesQueryV1(organizationUnitId: number)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.ActiveSharesQueryV1, TCh.Domain.DataSharing',
		'OrganizationUnitId': organizationUnitId,
	}
}

export function buildDataShareEmailsProvidersQueryV1(organizationUnitId: string, workspaceId: string | null, projectId: string | null)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.DataShareEmailsProvidersQueryV1, TCh.Domain.DataSharing',
		'OrganizationUnitId': organizationUnitId,
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

export function buildEmailsAndGroupsQueryV1(organizationUnitId: string, workspaceId: string | null, projectId: string | null, emailsProviderName: string)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.EmailsAndGroupsQueryV1, TCh.Domain.DataSharing',
		'OrganizationUnitId': organizationUnitId,
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EmailsProviderName': emailsProviderName,
	}
}

export function buildResourceSharesQueryV1(resourceProviderName: string, resourceId: string)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.ResourceSharesQueryV1, TCh.Domain.DataSharing',
		'ResourceProviderName': resourceProviderName,
		'ResourceId': resourceId,
	}
}

export function buildShareNotificationQueryV1(id: string)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.ShareNotificationQueryV1, TCh.Domain.DataSharing',
		'Id': id,
	}
}

export function buildShareQueryV1(resourceProviderName: string, resourceId: string, id: string)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.ShareQueryV1, TCh.Domain.DataSharing',
		'ResourceProviderName': resourceProviderName,
		'ResourceId': resourceId,
		'Id': id,
	}
}

export function buildSharesForEmailQueryV1(email: string)
{
	return {
		'$type': 'TCh.Domain.DataSharing.Shares.Queries.SharesForEmailQueryV1, TCh.Domain.DataSharing',
		'Email': email,
	}
}

